export class AvatarImageFallbackListener {
    public static bindDocumentImageError(onError: (event: Event) => void): void {
        document.addEventListener("error", onError, true);
    }
}
